<!--
	Note: this doctype is also used for the VerdictPage.
-->

<template>
	<article class="d-hearing-page-custom">
		<PageHeader
			use-wide-image
			v-bind="{
				...$attrs,
				...$props,
			}"
		/>

		<BlockList
			v-if="contentElements && contentElements.length"
			class="relative mt-5xl"
			:block-list="contentElements"
		>
			<template #aside>
				<div
					:class="[
						'd-hearing-page-custom__aside',
						'>=1024:sticky >=1024:top-6xl',
						'flex flex-col gap-y-xl',
						'pb-3xl >=1024:pb-0',
					]"
				>
					<div class="d-hearing-page-custom__buttons">
						<NuxtLinkExt
							v-if="link && link.length"
							:to="link[0].url"
							:target="link[0].target"
							:class="[
								'd-hearing-page-custom__aside-link',
								'w-full h-48 >=1024:h-full',
							]"
						>
							<BaseButton
								:class="[
									'd-hearing-page-custom__aside-button',
									'w-full h-full rounded-full',
								]"
								v-text="link[0].name"
							></BaseButton>
						</NuxtLinkExt>

						<!-- <BaseButton
							light
							:class="[
								'd-hearing-page-custom__aside-button',
								'h-48 >=1024:h-full',
							]"
						>
							Se indkomne høringssvar
							<template #icon>
								<SvgArrow class="transform rotate-90" />
							</template>
						</BaseButton> -->
					</div>

					<div
						:class="[
							'flex flex-col gap-y-md',
							'font-darker-grotesque text-aside',
						]"
					>
						<div v-if="topics" class="flex flex-col gap-y-2xs">
							<div
								class="uppercase font-bold text-aside-title"
								v-text="'Type'"
							></div>

							<div class="font-medium" v-text="topics.name"></div>
						</div>

						<div v-if="area" class="flex flex-col gap-y-2xs">
							<div
								class="upper case font-bold text-aside-title"
								v-text="'Område'"
							></div>

							<div class="font-medium" v-text="area.name"></div>
						</div>

						<div v-if="deadline" class="flex flex-col gap-y-2xs">
							<div
								class="uppercase font-bold text-aside-title"
								v-text="
									template === 'VerdictPage'
										? 'Klagefrist'
										: 'Høringsfrist'
								"
							></div>

							<div
								class="font-medium"
								v-text="computedDate(deadline)"
							></div>
						</div>

						<div v-if="published" class="flex flex-col gap-y-2xs">
							<div
								class="uppercase font-bold text-aside-title"
								v-text="'Offentliggjort'"
							></div>

							<div
								class="font-medium"
								v-text="computedDate(published)"
							></div>
						</div>
					</div>
				</div>
			</template>
		</BlockList>

		<FeedbackModule
			v-if="!hideFeedback"
			:feedback="feedback"
			class="mt-7xl"
		/>
	</article>
</template>

<script>
import { mapState } from 'vuex';

import PageHeader from '~/components/main/PageHeader';
import BlockList from '~/components/main/BlockList';
import FeedbackModule from '~/components/shared/FeedbackModule';

export default {
	name: 'MainHearingPageCustom',

	components: {
		PageHeader,
		BlockList,
		FeedbackModule,
	},

	inheritAttrs: false,

	props: {
		contentElements: {
			type: Array,
			default: () => [],
		},
		hideFeedback: {
			type: Boolean,
			default: false,
		},
		feedback: Object,
		link: { type: Array },
		topics: { type: Array },
		area: { type: Object },
		deadline: { type: String },
		published: { type: String },
	},

	computed: {
		...mapState({
			template: (state) => state.template,
		}),
	},

	methods: {
		computedDate(datetime) {
			const date = new Date(datetime);
			date.setHours(date.getHours() - 2);
			const day = `0${date.getDate()}`.slice(-2);
			const month = `0${date.getMonth() + 1}`.slice(-2);
			const year = date.getFullYear();

			return `${day}.${month}.${year}`;
		},
	},
};
</script>

<style lang="postcss">
.d-hearing-page-custom__aside-button .c-base-button__inner {
	@apply justify-center !important;
}

@screen >=1024 {
	.d-hearing-page-custom__aside .c-base-button__inner,
	.d-hearing-page-custom__aside .c-base-button__text {
		@apply w-min break-normal;
	}

	.d-hearing-page-custom__aside-link .c-base-button__inner {
		width: calc(100% + 4px * 2);
		@apply break-normal;
	}

	.d-hearing-page-custom__aside-link .c-base-button__text {
		@apply mx-auto break-normal;
	}
}

@screen >=1024 {
	.d-hearing-page-custom__buttons {
		width: calc(
			var(--theme-layout-column-of-12) * 2 + var(--theme-layout-gutter) *
				2
		);
	}
}
</style>
